"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var AXSFlexItem_1 = __importDefault(require("../../layout/AXSFlexItem"));
var colors_1 = require("../../constants/colors");
var get_1 = __importDefault(require("lodash/get"));
var axs_icons_1 = require("../../axs-icons");
var classnames_1 = __importDefault(require("classnames"));
var utils_1 = require("../../utils");
var UpDown = styled_components_1.default(AXSFlexItem_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  color: ", ";\n  font-size: ", ";\n  opacity: ", ";\n  padding: 0 5px;\n  user-select: none;\n"], ["\n  cursor: pointer;\n  color: ",
    ";\n  font-size: ",
    ";\n  opacity: ", ";\n  padding: 0 5px;\n  user-select: none;\n"])), function (_a) {
    var upDownColor = _a.upDownColor, upDownActiveColor = _a.upDownActiveColor, active = _a.active, theme = _a.theme;
    return utils_1.parseThemePath(active ? upDownActiveColor : upDownColor, theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var upDownSize = _a.upDownSize, theme = _a.theme;
    return upDownSize ? get_1.default(upDownSize, theme, '28px') : '28px';
}, function (_a) {
    var disabled = _a.disabled;
    return disabled ? '.3' : '1';
});
var Count = styled_components_1.default(AXSFlexItem_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border-bottom: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: bold;\n  line-height: 58px;\n  margin-top: ", ";\n  min-width: 60px;\n  padding: ", ";\n  text-align: center;\n  user-select: none;\n"], ["\n  border-bottom: ",
    ";\n  color: ",
    ";\n  font-size: ", ";\n  font-weight: bold;\n  line-height: 58px;\n  margin-top: ", ";\n  min-width: 60px;\n  padding: ", ";\n  text-align: center;\n  user-select: none;\n"])), function (_a) {
    var counterBorderColor = _a.counterBorderColor, theme = _a.theme, vertical = _a.vertical;
    return vertical === false ? "1px solid " + utils_1.parseThemePath(counterBorderColor, theme, colors_1.colors.BLUE_300) : 'none';
}, function (_a) {
    var counterColor = _a.counterColor, theme = _a.theme, active = _a.active, counterActiveColor = _a.counterActiveColor;
    return utils_1.parseThemePath((active ? counterActiveColor : counterColor), theme, colors_1.colors.BLUE_300);
}, function (_a) {
    var counterSize = _a.counterSize, theme = _a.theme;
    return utils_1.parseThemePath(counterSize, theme, '48px');
}, function (_a) {
    var vertical = _a.vertical;
    return vertical === false ? '0' : '-5px';
}, function (_a) {
    var vertical = _a.vertical;
    return vertical === false ? '0 25px' : '0';
});
var AXSCounter = function (_a) {
    var defaultCount = _a.defaultCount, disabled = _a.disabled, stepBy = _a.stepBy, maxCount = _a.maxCount, minCount = _a.minCount, counterColor = _a.counterColor, active = _a.active, activeBorderColor = _a.activeBorderColor, counterSize = _a.counterSize, upDownSize = _a.upDownSize, upDownColor = _a.upDownColor, className = _a.className, vertical = _a.vertical, handleChange = _a.handleChange, counterBorderColor = _a.counterBorderColor, counterActiveColor = _a.counterActiveColor, upDownActiveColor = _a.upDownActiveColor, props = __rest(_a, ["defaultCount", "disabled", "stepBy", "maxCount", "minCount", "counterColor", "active", "activeBorderColor", "counterSize", "upDownSize", "upDownColor", "className", "vertical", "handleChange", "counterBorderColor", "counterActiveColor", "upDownActiveColor"]);
    var _b = React.useState(defaultCount), count = _b[0], setCount = _b[1];
    var handleUp = function (count) {
        setCount(count);
        handleChange(count);
    };
    var handleDown = function (count) {
        setCount(count);
        handleChange(count);
    };
    return (React.createElement(AXSFlex_1.default, __assign({ className: classnames_1.default(['c-axs-counter', className]), alignItems: "center" }, props),
        React.createElement(UpDown, { active: active, className: "c-axs-counter__down", disabled: count - stepBy < minCount, onClick: !disabled ? function () { return handleDown(count - stepBy > minCount ? count - stepBy : minCount); } : null, role: "button", upDownActiveColor: upDownActiveColor, upDownColor: upDownColor, upDownSize: upDownSize },
            React.createElement(axs_icons_1.IconMinus, null)),
        React.createElement(Count, { active: active, className: "c-axs-counter__count", counterActiveColor: counterActiveColor, counterBorderColor: counterBorderColor, counterColor: counterColor, counterSize: counterSize, vertical: vertical }, count),
        React.createElement(UpDown, { active: active, className: "c-axs-counter__up", disabled: count + stepBy > maxCount, onClick: !disabled ? function () { return handleUp(count + stepBy < maxCount ? count + stepBy : maxCount); } : null, role: "button", upDownActiveColor: upDownActiveColor, upDownColor: upDownColor, upDownSize: upDownSize },
            React.createElement(axs_icons_1.IconPlus, null))));
};
AXSCounter.defaultProps = {
    active: false,
    counterActiveColor: 'axsui.components.counter.counterActiveColor',
    counterBorderColor: 'axsui.components.counter.counterBorderColor',
    counterColor: 'axsui.components.counter.counterColor',
    counterSize: 'axsui.components.counter.counterSize',
    defaultCount: 0,
    disabled: false,
    maxCount: 999,
    minCount: 0,
    stepBy: 1,
    upDownActiveColor: 'axsui.components.counter.upDownActiveColor',
    upDownColor: 'axsui.components.counter.upDownColor',
    upDownSize: 'axsui.components.counter.upDownSize',
    vertical: false,
};
exports.default = AXSCounter;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map